import Vue from 'vue';

Vue.component('profile-index', () =>
    import(/* webpackChunkName: 'profile-index' */ './profile-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/profile/index.js